import axios from 'axios'
import store from '@state/store'

// Request interceptor
axios.interceptors.request.use((request) => {
  const token = store.getters['auth/accessToken']
  if (token) {
    request.headers.common.Authorization = `Bearer ${token}`
  }

  const locale = store.getters['lang/locale']
  if (locale) {
    request.headers.common['Accept-Language'] = locale
  }

  // request.headers['X-Socket-Id'] = Echo.socketId()

  return request
})

// Response interceptor
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { status } = error.response
    const config = error.response.config
    if (
      status === 401 &&
      store.getters['auth/accessToken'] &&
      !error.config.url.includes('/api/v1/refresh/') &&
      error.response.data !== 'Incorrect authentication credentials.'
    ) {
      try {
        const { access } = await store.dispatch('auth/validate')
        if (access) {
          config.headers.Authorization = 'Bearer ' + access
          return axios(config)
        }
      } catch (error) {
        return Promise.reject(error)
      }
    } else {
      return Promise.reject(error)
    }
  }
)
